import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ROUTES_NAMES } from "./Layout";
import { canAccessCampaigns } from "../campaigns/campaignAccess";

type CampaignRouteProps = {
  children: React.ReactNode;
};

const CampaignRoute: React.FC<CampaignRouteProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, hasProductAccess, user } = useAuth();
  const canAccess =
    (isAdmin || hasProductAccess("micontenido")) &&
    canAccessCampaigns(user?.companyId);

  if (!isAuthenticated) {
    return <Navigate to={ROUTES_NAMES.AUTH} replace />;
  }

  if (!canAccess) {
    return <Navigate to={ROUTES_NAMES.MIS_PODCASTS} replace />;
  }

  return <>{children}</>;
};

export default CampaignRoute;
